import { UnikoServiceTypes } from "src/app/services/payments-api.service";
import { availableServices } from "./available-services";

export const propertyFileConstitutionService = {
    title: 'propretyUpload.title',
    img: '../../../../assets/img/property-service-propertyupload.png',
    descPart1: `propertyUpload.descriptionPart1`,
    descPart2: `propertyUpload.descriptionPart2`,
    section1Title: 'whyChooseService',
    deliveryDays: 10,
    serviceFee: 300,
    whyChooseService: [
      {
        icon: 'icon-list-todo-alt',
        title: 'propertyUpload.whyChoose.title1',
        description: 'propertyUpload.whyChoose.description1'
      },
      {
        icon: 'icon-clone-copy-alt',
        title: 'propertyUpload.whyChoose.title2',
        description: 'propertyUpload.whyChoose.description2'
      },
    ],
    section2Title: 'nextSteps',
    nextSteps: [
      'propertyUpload.nextSteps1',
      'propertyUpload.nextSteps2',
      'propertyUpload.nextSteps3'
    ],
    section3Title: 'lookAtTheseServices.title',
    section3Description: 'lookAtTheseServices.description',
    services: availableServices.filter((service) => service.type !== UnikoServiceTypes.propertyFileConstitution),
    requestServiceButtonLabel: 'propertyUpload.requestPropertyUpload',
  }